export const extractSitesAndLocationsFromScope = (scope = []) => {
  const sites = scope.map((site) => site.value);
  const locations = scope.flatMap((site) => {
    const {locations = []} = site;
    return locations.map((location) => location.value);
  });

  return {sites, locations};
};
